<template>
  <div class="model-content">
    <div
      class="model_69"
      :class="
        posterList.lang == 'ug' || !posterList.lang ? 'model_ug' : 'model_zh'
      "
    >
      <div class="img-box">
        <img
          v-if="posterList.lang == 'ug' || !posterList.lang"
          style="width: 100%"
          :src="bg_list.url_ug"
        />
        <img
          v-if="posterList.lang == 'zh'"
          style="width: 100%"
          :src="bg_list.url_zh"
        />
      </div>

      <div class="merchant-name">
        <div class="merchant-name-title">{{ posterList.merchant_name }}</div>
      </div>

      <div class="merchant_img">
        <img :src="posterList.merchant_img" alt="" />
      </div>

      <div class="merchant_qrcode">
        <img :src="posterList.merchant_qrcode" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "model_69",
  data() {
    return {
      posterList: {},
      bg_list: {
        url_zh: require("../../img/poster/model_69_zh.png"),
        url_ug: require("../../img/poster/model_69_ug.png"),
      },
    };
  },

  created() {
    this.canvasfortitle(this.$route.query.merchant_name, this.$route.query);
  },
  methods: {
    /**
     * 更新海报标题中的商户名称
     *
     * @param merchant_name 商户名称
     * @param query 查询参数
     */
    canvasfortitle(merchant_name, query) {
      let res_name = merchant_name.replaceAll("(", "-");
      res_name = res_name.replaceAll("（", "-");
      res_name = res_name.replaceAll(")", " ");
      res_name = res_name.replaceAll("）", " ");
      this.posterList = query;
      this.posterList["merchant_name"] = res_name;
    },
  },
};
</script>

<style scoped>
.model-content {
  width: 390px;
  height: 693px;
  position: relative;
  margin: auto;
  display: flex;
  justify-content: center;
}

.model_69 {
  width: 390px;
  height: 693px;
  position: relative;
}

.model_ug {
  direction: rtl;
}

.model_zh {
  direction: ltr;
}

.img-box {
  width: 100%;
  height: 100%;
}

.merchant-name {
  position: absolute;
  top: 100px;
  right: 50%;
  transform: translateX(50%);
  color: #ffffff;
  width: 290px;
  height: 56px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.merchant-name-title {
  font-size: 22px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /*垂直排列*/
  line-clamp: 2;
  -webkit-line-clamp: 2;
  /*只显示6行*/
  overflow: hidden;
  /*溢出隐藏*/
  text-overflow: ellipsis;
  /*省略号代替*/
}

.merchant_img {
  position: absolute;
  top: 161px;
  left: 50%;
  transform: translateX(-49.2%);
  width: 154px;
  height: 154px;
  border-radius: 5px;
}

.merchant_img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.merchant_qrcode {
  position: absolute;
  bottom: 27px;
  left: 51px;
  width: 74px;
  height: 74px;
  background-color: #fff;
  border-radius: 50%;
  overflow: hidden;
}

.merchant_qrcode img {
  width: 100%;
  height: 100%;
}
</style>
